import * as Yup from "yup";
import { useAvailableTreatmentPacks } from "../hooks/useAvailableTreatmentPacks";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { Preparation } from "../models/generated/graphql";
import { GeneralFieldController } from "./general-field-controller";

export class ProductNameFieldController extends GeneralFieldController {
	override useControlProps(): FlexControlProps {
		const preparations = useAvailableTreatmentPacks(this.parent);

		return {
			controlType: "typeahead",
			getOptionLabel: (preparation: Preparation) => `${preparation.BrandName} (${preparation.GenericName})`,
			property: "id",
			options: preparations,
		};
	}

	protected override createFieldValidationRuleByDataType(): Yup.AnySchema {
		return Yup.object().nullable();
	}
}
